import moment from "moment";
import qs from "qs";
import hbscan from "../../api/hbscan";
import IPeriodic, {
    EPeriodicStatus,
    PeriodicDetails,
    PeriodicDisplayDate,
} from "../../models/periodic/periodic";
import { ITaskProfile } from "../../models/task";
import Auth from "../auth/AuthService";
import { ITaskHistory } from "../../models/periodic/taskHistory";
import { IRescheduleHistory } from "../../models/periodic/rescheduleHistory";

class PeriodicService {
    async GetRelatedTasks(localId: number, currentScheduleId: number, limit?: number): Promise<IPeriodic[]> {
        const url = `/api/hbscan/TaskSchedule/GetRelatedTasks`;
        try {
            const response = await hbscan.get<IPeriodic[]>(url, {
                headers: { Authorization: Auth.guid },
                params: { localId, currentScheduleId, limit },
            });
            return response.data;
        } catch (error) {
            return [];
        }
    }


    private getStatus = (periodic: IPeriodic) => {
        if (!periodic.status) periodic.status = EPeriodicStatus.Todo
        if (periodic.status !== EPeriodicStatus.Todo) return periodic.status;
        return moment(periodic.scheduleDate).isBefore(moment(), "day")
            ? EPeriodicStatus.Overdue
            : periodic.executionDate
                ? EPeriodicStatus.ToVerify
                : EPeriodicStatus.Todo;
    };

    async GetPeriodics(companyId: number): Promise<PeriodicDetails[]> {
        const url = "/api/hbscan/TaskSchedule/GetTasksScheduleByCompanyId";
        const periodics = (
            await hbscan.get<PeriodicDetails[]>(url, {
                headers: { Authorization: Auth.user?.guid || "" },
                params: { companyId },
            })
        ).data || [];

        return periodics.map((periodic) => ({
            ...periodic,
            schedule: {
                ...periodic.schedule,
                status: this.getStatus(periodic.schedule),
            },
        }));
    }


    async GetPeriodic(scheduleTaskId: number): Promise<PeriodicDisplayDate> {
        const url = "/api/hbscan/TaskSchedule/GetTaskSchedule";

        return (
            await hbscan.get<PeriodicDisplayDate>(url, {
                headers: { Authorization: Auth.guid },
                params: { scheduleTaskId },
            })
        ).data || [];
    }


    async GetTasksWithProfile(localIds: number[]): Promise<ITaskProfile[]> {
        const URI = "/api/hbscan/Task/GetTasksByLocals";

        const req = await hbscan.get<ITaskProfile[]>(URI, {
            headers: { Authorization: Auth.guid },
            params: { localIds },
            paramsSerializer: (params) => {
                return qs.stringify(params, { arrayFormat: "repeat" });
            },
        });

        return req.data || [];
    }



    PostPeriodic = async (
        taskIds: number[],
        localIds: number[],
        scheduleDates: Date[]
    ) => {
        const URI = "/api/hbscan/TaskSchedule/PostTaskSchedule";
        const request = { taskIds, localIds, scheduleDates };

        return (
            await hbscan.post(URI, request, {
                headers: { Authorization: Auth.guid },
            })
        ).data;
    };





    async GetTaskHistory(periodicId: number): Promise<ITaskHistory[]> {
        const url = "/api/hbscan/TaskSchedule/GetTaskHistory";
        return (
            await hbscan.get<ITaskHistory[]>(url, {
                headers: { Authorization: Auth.guid },
                params: { periodicId },
            })
        ).data || [];
    }

    ExecuteAction = async (formData: FormData) => {
        const URI = "/api/hbscan/TaskSchedule/ExecuteAction";

        return (
            await hbscan.post(URI, formData, {
                headers: {
                    Authorization: Auth.guid,
                    "Content-Type": "multipart/form-data"
                },
            })
        ).data;
    };

    async ReschedulePeriodic(periodicId: number, newDate: Date, reason: string): Promise<boolean> {
        const url = "/api/hbscan/TaskSchedule/ReschedulePeriodic";
        const response = await hbscan.put<boolean>(url, null, {
            headers: { Authorization: Auth.guid },
            params: {
                periodicId,
                newDate: moment(newDate).format("YYYY-MM-DD"),
                reason
            }
        });
        return response.data;
    }

    async GetRescheduleHistory(periodicId: number): Promise<IRescheduleHistory[]> {
        const url = "/api/hbscan/TaskSchedule/GetRescheduleHistory";
        const response = await hbscan.get<IRescheduleHistory[]>(url, {
            headers: { Authorization: Auth.guid },
            params: { periodicId }
        });
        return response.data || [];
    }

}

const periodidService = new PeriodicService();

export default periodidService;
